import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ac19ab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zones-modal" }
const _hoisted_2 = { class: "zones-modal__header" }
const _hoisted_3 = { class: "zones-modal__tabs" }
const _hoisted_4 = { class: "zones-modal__container" }
const _hoisted_5 = {
  key: 0,
  class: "container__image"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/zones-modal/1-5.png" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "container__grid"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid__description" }, "Все поселки из таблицы ниже входят в Зону 6. Если вы не нашли нужный поселок, то он входит в Зону 7.", -1))
const _hoisted_10 = {
  key: 0,
  class: "grid__state"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "Произошла ошибка при получении данных", -1))
const _hoisted_12 = { class: "grid__container" }
const _hoisted_13 = { class: "column__category" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Определить зону по направлению",
    "without-footer": "",
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["tabs__tab", { 'tab--active': _ctx.state.active_tab === 1 }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.active_tab = 1))
            }, "Зоны 1-5", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["tabs__tab", { 'tab--active': _ctx.state.active_tab === 2 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.active_tab = 2))
            }, "Зоны 6-7", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state.active_tab === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : (_ctx.state.active_tab === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  (_ctx.state.is_loading || _ctx.state.is_failed)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_ctx.state.is_loading)
                          ? (_openBlock(), _createBlock(_component_loader, {
                              key: 0,
                              class: "primary"
                            }))
                          : (_ctx.state.is_failed)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _hoisted_11,
                                _createVNode(_component_the_button, {
                                  class: "primary small",
                                  onClick: _ctx.loadCitiesGrouped
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Перезагрузить")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ], 64))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.cities_groups, (group, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "container__column",
                        key: `city-group-${i}`
                      }, [
                        _createElementVNode("div", _hoisted_13, _toDisplayString(group.name), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.cities, (city, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "column__item",
                            key: `group-${i}-city-${j}`
                          }, _toDisplayString(city.name), 1))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["onCancel"]))
}